import {
  SANCTION_FIELDS_FETCH_REQUEST,
  SANCTION_FIELDS_FETCH_REQUEST_FAILURE,
  SANCTION_FIELDS_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const sanctionFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SANCTION_FIELDS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SANCTION_FIELDS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case SANCTION_FIELDS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        payload: [],
      });

    default:
      return state;
  }
};

export default sanctionFieldsReducer;
